import React from 'react';
import { IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import { merge } from 'lodash';
import { BasicBlock } from '../../../components/BasicBlock';
import { createBlock, t } from '../../../utils';
import { TableRow } from '../TableRow';

export type ITable = IBlockData<
    {
        'background-color'?: string;
        border?: string;
        'border-radius'?: string;
        'inner-border'?: string;
        'inner-border-radius'?: string;
        padding?: string;
        'text-align'?: string;
        'vertical-align'?: string;
        width?: string;
    },
    {}
>;
export const Table = createBlock<ITable>({
    get name() {
        return t('Table');
    },
    type: BasicType.TABLE,
    create: (payload: any) => {
        const defaultData: ITable = {
            type: BasicType.TABLE,
            data: {
                value: {},
            },
            attributes: {},
            children: [
                TableRow.create({}),],
        };
        return merge(defaultData, payload);
    },
    validParentType: [BasicType.COLUMN],
    render(params: any) {
        return (
            <BasicBlock
                params={params}
                tag='mj-table'
            />
        );
    },
});
